import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";


const ImageCarousel = ({ images }) => {
    return (
      <div className="mt-1">
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={5}
          slidesPerView={2.5} // Show multiple images
          navigation
          autoplay={{ delay: 3000 }}
          loop
        >
          {images.map((img, index) => (
            <SwiperSlide key={index}>
               <img
              src={img}
              alt={`Slide ${index + 1}`}
              className="image-slide"
            />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  };

export default ImageCarousel;
